module.exports = __webpack_public_path__ + "static/media/livis-logo.f1e7421c.svg";